<template>
    <div class="shrink-0">
        <a v-if="linkToProductPage" :href="productPageHref">
            <img :src="imgSrc('1x')" :srcset="imgSrcset" :alt="imgAlt" />
        </a>
        <img v-else :src="imgSrc('1x')" :srcset="imgSrcset" :alt="imgAlt" />
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStaticAsset } from "../../functions/useStaticAsset";

const props = withDefaults(
    defineProps<{
        cartItem?: any;
        linkToProductPage?: boolean;
    }>(),
    {
        linkToProductPage: true,
    },
);

const { asset } = useStaticAsset();
const imgAlt = computed(
    () =>
        `${props.cartItem.product_option.product.name} (${props.cartItem.product_option.product.description})`,
);
const imgSrcset = computed(
    () => `${imgSrc("1x")} 1x, ${imgSrc("2x")} 2x, ${imgSrc("3x")} 3x`,
);
const productPageHref = computed(
    () =>
        `/products/${props.cartItem.product_option.product.name.toLowerCase()}`,
);

function imgSrc(size: string): string {
    const slug = props.cartItem.product_option.product.slug;
    const upc = props.cartItem.product_option.upc;
    const image = props.cartItem.product_option.image.replace(
        "@1x",
        `@${size}`,
    );

    return asset(`/images/products/${slug}/${upc}/${image}`);
}
</script>
